import React from 'react';

import BackDrop from './Backdrop'
import styles from './Modal.module.css'

const Modal = (props) => (
  <>
    <BackDrop show={props.show} onClick={props.modalClosed} />
    <div
      className={[styles.Modal, styles[props.className]].join(' ')}
      onClick={props.modalClosed}
      style={{
        opacity: props.show ? '1' : '0',
        visibility: props.show ? 'visible' : 'hidden'
      }}>
      {props.children}
    </div>
  </>
)

//const shouldNotUpdate = (prevProps, nextProps) => (prevProps.show === nextProps.show && prevProps.children === nextProps.children)

//export default React.memo(Modal, shouldNotUpdate);

export default Modal;